
import { FormEventType } from '@/ui-kit/components/form/enums';
import { SoldDataEvent } from '@/constants/AnalyticEvents';
import BaseForm from '../../shared/components/mixins/BaseForm';
import BaseFilter from '../../shared/components/base-filter';
import FormButtons from '../../shared/components/forms/buttons';
import TrackEvent from '../../shared/mixins/TrackEvent';
import { DatePeriodFormControlName } from '../../shared/components/forms/date-period/enums';
import { LocationFormControlName } from '../../shared/components/forms/location/enums';
import FormProps from '../../shared/components/mixins/FormProps';
import { BaseFilterProperty } from '../../shared/components/base-filter/enums';
import { ButtonsProperty } from '../../shared/components/forms/buttons/enums';
import Auth from '@/mixins/auth';

export default {
  name: 'SoldDataFiltersForm',
  components: {
    FormButtons,
    BaseFilter,
  },
  mixins: [BaseForm, FormProps, TrackEvent, Auth],
  data() {
    return {
      ButtonsProperty,
      BaseFilterProperty,
      FormEventType,
      submitTrackEvent: SoldDataEvent.FiltersApplyClick,
      resetTrackEvent: SoldDataEvent.FiltersResetClick,
      trackEventByControlName: {
        [DatePeriodFormControlName.DatePeriod]: SoldDataEvent.DatePeriodSelect,
        [LocationFormControlName.Province]: SoldDataEvent.ProvinceSelect,
        [LocationFormControlName.City]: SoldDataEvent.CitySelect,
        [LocationFormControlName.Community]: SoldDataEvent.CommunitySelect,
      },
    };
  },
  methods: {
    async handleSubmit() {
      const isAuthenticated = await this.checkAuthAndRedirect();

      this.formGroup.validate();

      if (this.formGroup.isValid && isAuthenticated) {
        this.trackSubmit();
        this.$emit(FormEventType.Submit, this.formGroup.value);
      }
    },
    handleReset() {
      this.trackReset();
      this.formGroup.reset();
    },
  },
};
